<template>
  <div>
    <van-nav-bar title="发票申请" left-arrow @click-left="$router.back()" />
    <van-form ref="invoiceForm" @submit="handleSubmit">
      <van-tabs v-model="active">
        <van-tab title="发票信息">
          <van-row>
            <van-col :span="6" class="form-select">
              发票类型
            </van-col>
            <van-col :span="18">
              <base-select v-model="form.type_name" :options="CONST.INVOICE_TYPE" @change="onInvoiceTypeChange" />
            </van-col>
          </van-row>
          <base-textarea v-model="form.payer" label="发票抬头" :required="true" />
          <base-input v-model="form.taxpayer_code" label="税号" :required="true" />
          <base-textarea v-model="form.addr_phone" label="地址/电话" :required="isZP"
                         :rules="[{ required: isZP, message: '请输入地址/电话'}]" />
          <base-textarea v-model="form.bank_account" label="开户行/账号" :required="isZP"
                         :rules="[{ required: isZP, message: '请输入开户行/账号'}]" />
          <base-input v-model="form.mobile" type="tel" label="短信手机号" :required="true"
                      :rules="[{ required: true, message: '请填写您的手机号码' }, { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误' }]"/>
          <van-row>
            <van-col :span="6" class="form-select">
              交接方式
            </van-col>
            <van-col :span="18">
              <base-select v-model="form.handover_type_name" :options="CONST.INVOICE_HANDOVER_TYPE"
                           @change="onInvoiceHandoverTypeChange" />
            </van-col>
          </van-row>
          <base-textarea v-if="showHandoverRemark" v-model="form.handover_remark" label="运单号/邮箱"
                         :required="requiredOfHandoverRemark" />
          <base-textarea v-if="showAddress" v-model="form.address" label="收件人地址"
                         :required="requiredOfAddress" />
          <base-textarea v-model="form.comment" label="备注" />
        </van-tab>
        <van-tab title="发票明细">
          <template v-for="(detail, index) in form.details">
            <van-swipe-cell :key="index">
              <div>
                <base-textarea v-model="detail.item" label="货物或应税劳务名称" :required="true" />
                <base-input v-model="detail.specification" label="规格型号" :required="true" />
                <base-input v-model="detail.unit" label="单位" :required="true" />
                <base-input-number v-model="detail.count" label="数量" :required="true"
                                   @change="onCountOrPriceChange(detail)" />
                <base-input-number v-model="detail.price" label="单价" :required="true"
                                   @change="onCountOrPriceChange(detail)" />
                <base-input-number v-model="detail.amount" label="金额" :required="true"
                                   @change="onAmountChange(detail)" />
              </div>
              <template #right>
                <van-button square type="danger" text="删除" @click.prevent="handleDel(detail)" class="delete-button" />
              </template>
            </van-swipe-cell>
          </template>
          <van-row>
            <van-col :span="24">
              <base-button @click="handleAdd">新增明细</base-button>
            </van-col>
          </van-row>
        </van-tab>
      </van-tabs>
      <van-submit-bar :price="form.amount * 100" native-type="submit" button-text="提交" />
    </van-form>
  </div>
</template>

<script>
import { addInvoice, modifyInvoice, addInvoiceDetail, modifyInvoiceDetail, deleteInvoiceDetail } from '@/api/invoice'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      active: 0,
      showHandoverRemark: false,
      requiredOfHandoverRemark: true,
      showAddress: false,
      requiredOfAddress: true,
      form: {
        id: null,
        type: null,
        type_name: '',
        payer: '',
        taxpayer_code: '',
        addr_phone: '',
        bank_account: '',
        mobile: '',
        handover_type: null,
        handover_type_name: '',
        handover_remark: '',
        address: '',
        comment: '',
        details: [],
        amount: 0 // 发票总金额
      },
      newRowOfDetail: {
        id: null,
        item: '',
        specification: '',
        unit: '',
        count: null,
        price: null,
        amount: null
      }
    }
  },
  computed: {
    ...mapGetters(['currClient', 'currInvoice']),
    isZP() {
      return this.form.type_name === '纸质专票'
    }
  },
  mounted() {
    if (this.currInvoice) {
      const invoice = this._.cloneDeep(this.currInvoice)
      this.$store.dispatch('invoice/setInvoice', null)
      Object.assign(this.form, invoice)
      const invoiceType = this.CONST.INVOICE_TYPE.find(type => type.id === invoice.type)
      if (invoiceType) {
        this.form.type_name = invoiceType.name
      }
      const invoiceHandoverType = this.CONST.INVOICE_HANDOVER_TYPE.find(type => type.id === invoice.handover_type)
      if (invoiceHandoverType) {
        this.form.handover_type_name = invoiceHandoverType.name
      }
      this.onInvoiceTypeChange(this.form.type_name, invoiceType)
    } else {
      this.form.details.push(this._.cloneDeep(this.newRowOfDetail))
      const invoiceType = this.CONST.INVOICE_TYPE.find(type => type.name === '电子发票')
      this.form.type = invoiceType.id
      this.form.type_name = invoiceType.name
      this.onInvoiceTypeChange(this.form.type_name, invoiceType)
    }
  },
  methods: {
    onInvoiceTypeChange(val, invoiceType) {
      this.form.type = invoiceType.id
      if (val === '电子发票') {
        this.form.handover_type = 3
        this.form.handover_type_name = '邮箱'
        this.showHandoverRemark = true
        this.requiredOfHandoverRemark = true
        this.CONST.INVOICE_HANDOVER_TYPE.forEach(type => {
          if (type.name === '邮箱') {
            type.disabled = false
          } else {
            type.disabled = true
          }
        })
      } else {
        if (this.form.handover_type_name === '邮箱') {
          this.form.handover_type = 1
          this.form.handover_type_name = '面对面'
        }
        this.CONST.INVOICE_HANDOVER_TYPE.forEach(type => {
          if (type.name === '邮箱') {
            type.disabled = true
          } else {
            type.disabled = false
          }
        })
        this.onInvoiceHandoverTypeChange(this.form.handover_type_name, {
          id: this.form.handover_type,
          name: this.form.handover_type_name
        })
      }
      this.$refs['invoiceForm'].resetValidation()
    },
    onInvoiceHandoverTypeChange(val, invoiceHandoverType) {
      this.form.handover_type = invoiceHandoverType.id
      if (val === '面对面') {
        this.form.handover_remark = ''
        this.form.address = ''
        this.showHandoverRemark = false
        this.requiredOfHandoverRemark = false
        this.showAddress = false
        this.requiredOfAddress = false
      } else if (val === '快递') {
        this.showHandoverRemark = true
        this.showAddress = true
        this.requiredOfHandoverRemark = false
        this.requiredOfAddress = true
      } else if (val === '邮箱') {
        this.form.address = ''
        this.showHandoverRemark = true
        this.requiredOfHandoverRemark = true
        this.showAddress = false
        this.requiredOfAddress = false
      }
    },
    onCountOrPriceChange(detail) {
      if (detail.tag) {
        detail.tag = false
      } else {
        detail.amount = (+detail.count || 0) * (+detail.price || 0)
        this.calcTotalAmount()
      }
    },
    onAmountChange(detail) {
      detail.tag = true
      if (!detail.count) {
        detail.count = 1
      }
      detail.price = detail.amount / detail.count
      this.calcTotalAmount()
    },
    calcTotalAmount() {
      let amount = 0
      if (this.form.details && this.form.details.length > 0) {
        this.form.details.forEach(detail => {
          detail.amount = (+detail.amount || 0)
          amount += detail.amount
        })
      }
      this.form.amount = amount
    },
    handleAdd() {
      this.form.details.push(this._.cloneDeep(this.newRowOfDetail))
    },
    handleDel(detail) {
      if (this.form.details.length > 1) {
        if (detail.id > 0) {
          this.confirm('确定删除发票明细吗？').then(() => {
            deleteInvoiceDetail({
              id: +detail.id
            }).then(resp => {
              this.success(resp.msg)
              const index = this.form.details.indexOf(detail)
              this.form.details.splice(index, 1)
              this.calcTotalAmount()
              modifyInvoice({
                id: this.form.id,
                amount: this.form.amount
              }).then(resp => {
                this.success(resp.msg)
                this.$router.back()
              })
            })
          })
        } else {
          const index = this.form.details.indexOf(detail)
          this.form.details.splice(index, 1)
        }
      } else {
        this.warning('发票明细不能为空，请您至少保留一项发票明细')
      }
    },
    handleSubmit() {
      if (this.form.details.length > 0 && this.form.amount > 0) {
        for (let i = 0, j = this.form.details.length; i < j; i++) {
          const detail = this.form.details[i]
          if (detail.item) {
            if (!detail.specification) {
              this.warning('规格型号不能为空')
              return
            } else if (!detail.unit) {
              this.warning('单位不能为空')
              return
            } else if (!detail.count) {
              this.warning('数量不能为空')
              return
            } else if (!detail.price) {
              this.warning('单价不能为空')
              return
            } else if (!detail.amount) {
              this.warning('金额不能为空')
              return
            }
          }
          if (detail.amount && !detail.item) {
            this.warning('货物或应税劳务名称不能为空')
            return
          }
        }
        this.calcTotalAmount()
        this.form.client_name = this.currClient.client_name
        this.form.client_id = this.currClient.client_id
        this.form.wxfwh_client_id = this.currClient.client_id
        if (this.form.id > 0) {
          modifyInvoice(this.form).then(resp => {
            this.form.details.forEach(async (detail) => {
              delete detail.tag // 不删除tag提交后台报错
              detail.main_id = this.form.id
              if (detail.id > 0) {
                await modifyInvoiceDetail(detail)
              } else {
                await addInvoiceDetail(detail)
              }
            })
            this.success(resp.msg)
            this.$router.back()
          })
        } else {
          addInvoice(this.form).then(resp => {
            this.success(resp.msg)
            this.$router.back()
          })
        }
      } else {
        this.active = 1
        this.warning('发票明细不能为空，请您填写发票明细')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/invoice/edit.vue